import React, { useRef, useState } from 'react';
import { ModalContainer } from './Styles';
import useGalleryState from '../../hooks/useGalleryState';
import ExpandedModal from './ExpandedModal/ExpandedModal';
import ModalContent from './ExpandedModal/ModalContent';
import ModalThumbnailList from './ExpandedModal/ModalThumbnailList';
import CountBadge from '../Product/CountBadge';
import MasonryGallery from './MasonryGallery';
import CarouselGallery from './CarouselGallery';

const FenderProductGallery: React.FC = () => {
  const thumbnailListRef = useRef<HTMLDivElement>(null);
  const thirdRowRef = useRef<HTMLDivElement>(null);
  const [showMore, setShowMore] = useState(false);

  const {
    loading,
    mediaItems,
    modalVisible,
    modalImageMaxHeight,
    iframeDimensions,
    selectedVariantData,
    videoIndex,
    modalSelectedImageIndex,
    marketingVideoPreview,
    selectedMediaIndex,
    showUpArrow,
    showDownArrow,
    siteId,
    screenWidth,
    galleryType,
    handleGalleryScroll,
    handleThumbnailScroll,
    handleGalleryClick,
    handleThumbnailClick,
    handleModalGalleryScroll,
    handleModalThumbnailClick,
    openModalAtIndex,
  } = useGalleryState(thumbnailListRef);

  const handleTileClick = (index: number) => {
    openModalAtIndex(index);
  };

  const handleToggleShowMore = () => {
    if (showMore && thirdRowRef.current) {
      thirdRowRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setShowMore(!showMore);
  };

  if (loading) {
    return <p>Loading...</p>;
  }
  if (!mediaItems || mediaItems.length === 0) {
    return <p>No media available</p>;
  }

  return (
    <>
      {modalVisible ? (
        <ModalContainer onClick={e => e.stopPropagation()}>
          <ExpandedModal toggleShowModal={handleGalleryClick} modalVisible={modalVisible}>
            <CountBadge
              modalSelectedImageIndex={modalSelectedImageIndex}
              mediaItemsLength={mediaItems.length}
            />
            <ModalContent
              videoIndex={videoIndex}
              onGalleryScroll={handleModalGalleryScroll}
              mediaItems={mediaItems}
              selectedImageIndex={modalSelectedImageIndex}
              setSelectedIndex={handleModalThumbnailClick}
              modalImageMaxHeight={modalImageMaxHeight}
              iframeDimensions={iframeDimensions}
            />
          </ExpandedModal>
          <ModalThumbnailList
            screenWidth={screenWidth}
            images={selectedVariantData?.variantMedia?.images || []}
            onThumbnailClick={handleModalThumbnailClick}
            activeIndex={modalSelectedImageIndex}
            videoThumbnail={mediaItems[videoIndex]?.thumbUrl}
            videoIndex={videoIndex}
            id="image-gallery-modal-thumblist"
          />
        </ModalContainer>
      ) : (
        <>
          <MasonryGallery
            isDesktopHidden={galleryType === 'carousel'}
            mediaItems={mediaItems}
            handleTileClick={handleTileClick}
            handleGalleryClick={handleGalleryClick}
            showMore={showMore}
            handleToggleShowMore={handleToggleShowMore}
            marketingVideoPreview={marketingVideoPreview}
            videoIndex={videoIndex}
            iframeDimensions={iframeDimensions}
            thirdRowRef={thirdRowRef}
          />
          <CarouselGallery
            isDesktopHidden={galleryType === 'masonry'}
            screenWidth={screenWidth}
            mediaItems={mediaItems}
            selectedMediaIndex={selectedMediaIndex}
            handleThumbnailClick={handleThumbnailClick}
            handleGalleryScroll={handleGalleryScroll}
            handleThumbnailScroll={handleThumbnailScroll}
            showUpArrow={showUpArrow}
            showDownArrow={showDownArrow}
            siteId={siteId}
            selectedVariantData={selectedVariantData}
            handleGalleryClick={handleGalleryClick}
            videoIndex={videoIndex}
            thumbnailListRef={thumbnailListRef}
          />
        </>
      )}
    </>
  );
};

export default FenderProductGallery;
